<template>
  <v-col cols="12">
    <p class="font-weight-bold">
      {{ $t('client.set-password-info') }}
    </p>
    <v-row class="ma-0">
      <v-text-field
        v-model="password"
        data-testid="form-admin-set-password"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPassword ? 'text' : 'password'"
        :error-messages="adminPasswordErrors"
        :label="$t('client.property.adminPassword')"
        dense
        name="password"
        autocomplete="new-password"
        outlined
        clearable
        required
        @click:append="showPassword = !showPassword"
      ></v-text-field>

      <v-btn color="primary" class="ml-2" @click="savePassword">{{
        $t('save')
      }}</v-btn>
    </v-row>
    <v-divider></v-divider>
  </v-col>
</template>

<script lang="ts">
import ClientModule from '@/store/modules/ClientModule';
import SnackbarModule from '@/store/modules/SnackbarModule';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { minLength, required } from 'vuelidate/lib/validators';
import { getModule } from 'vuex-module-decorators';
import { helpers } from 'vuelidate/lib/validators';

const alphaNumGerman = helpers.regex('alphaNumGerman', /^[a-zA-Z0-9äöüßÄÖÜ]*$/);

@Component({
  components: {},
  mixins: [validationMixin],
  validations: {
    password: {
      required,
      minLength: minLength(8),
      alphaNumGerman,
    },
  },
})
export default class SetPasswordForAdmin extends Vue {
  @Prop()
  adminId!: string;

  clientModule: ClientModule = getModule(ClientModule, this.$store);
  snackbarModule: SnackbarModule = getModule(SnackbarModule, this.$store);

  loading = false;
  password: string | null = null;
  showPassword = false;

  async savePassword() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      console.log('Validation failed');
      console.log(this.$v);
      return;
    }
    try {
      this.loading = true;
      await this.clientModule.addNewAdminPassword({
        adminId: this.adminId,
        password: this.password?.trim() || '',
      });

      this.snackbarModule.showMessage({
        message: this.$i18n

          .t('client.snackbar.admin.passwordSuccess')
          .toString(),
        isSuccess: true,
      });
    } catch (error) {
      this.snackbarModule.showMessage({
        message: this.$i18n.t('client.snackbar.admin.passwordError').toString(),
        isSuccess: false,
      });
    } finally {
      this.loading = false;
    }
  }

  get adminPasswordErrors(): string[] {
    const errors: string[] = [];
    const requiredError = this.$t('client.form.adminPassword').toString();
    const minLength = this.$t('client.form.minLength').toString();
    const alphanumericError = this.$t('client.form.alphanumeric').toString();
    if (!this.$v.password.$dirty) return errors;
    !this.$v.password.required && errors.push(requiredError);
    !this.$v.password.minLength && errors.push(minLength);
    !this.$v.password.alphaNumGerman && errors.push(alphanumericError);
    return errors;
  }
}
</script>

<style lang="scss" scoped></style>
